import React from 'react'
import Img from 'gatsby-image'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import {
  AboutContainer,
  AboutWrapper,
  AboutLogoImgBg,
  AboutText,
  AboutData,
  AboutInfo,
  AboutLogoImg,
  AboutDataInfoWrapper,
  AboutDataInfoText,
  AboutDataInfoLink,
} from './About.styles'
import Grid from '../Grid'
import Social from '../Social'
import Icon from '../Icon'
import { useAboutQuery } from '../../querys'

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_node, children) => <AboutText>{children}</AboutText>,
  },
}

const About = () => {
  const { about, logo } = useAboutQuery()
  return (
    <AboutContainer>
      <AboutLogoImgBg>
        <Img fluid={logo.localFile.childImageSharp.fluid} />
      </AboutLogoImgBg>
      <Grid>
        <AboutWrapper>
          <AboutLogoImg fluid={logo.localFile.childImageSharp.fluid} />
          <AboutInfo>{documentToReactComponents(about, options)}</AboutInfo>
        </AboutWrapper>
        <AboutData>
          <AboutDataInfoWrapper padded>
            <Icon icon="at" />
            <AboutDataInfoLink href="mailto:info@yago.dev">
              info@yago.dev
            </AboutDataInfoLink>
          </AboutDataInfoWrapper>
          <AboutDataInfoWrapper padded>
            <Icon icon="map-marker-alt" />
            <AboutDataInfoText>London</AboutDataInfoText>
          </AboutDataInfoWrapper>
          <AboutDataInfoWrapper padded>
            <Icon icon="phone" />
            <AboutDataInfoLink href="tel:+447490303306">
              +44 7490 303306
            </AboutDataInfoLink>
          </AboutDataInfoWrapper>
          <AboutDataInfoWrapper padded>
            <Icon icon="door-open" />
            <AboutDataInfoText>Open to new roles</AboutDataInfoText>
          </AboutDataInfoWrapper>
        </AboutData>
        <Social />
      </Grid>
    </AboutContainer>
  )
}

export default About
